// Module
var code = `<div class="cycle-form" ng-if="\$ctrl.loanType.cycleCounting">
  <div class="cycle-item" ng-repeat="i in \$ctrl.range(0, \$ctrl.loanType.cycles.length-1)">
    <form-section-field field-title="i + 1 + (i == \$ctrl.loanType.cycles.length-1 ? ' - ... ': '') + ''">
      <cash ng-model="\$ctrl.loanType.cycles[i]"
        min="0.01"
        max="\$ctrl.loanType.maxAmount"
        ng-required="true"></cash>
    </form-section-field>
  </div>
  <form-section-field field-title="">
    <a ng-click="\$ctrl.add()" class="btn btn-success">Add</a>
    <a ng-click="\$ctrl.remove()" ng-if="\$ctrl.loanType.cycles.length > 1" class="btn btn-danger">Remove</a>
  </form-section-field>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/loan/details/forms/loan-cycle-counter.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;